<template>
	<ui-modal-template>
		<template v-slot:header>
			<div class="mt-6 px-6 py-2 px-6">
				<div class="flex justify-center px-6">
					<h1 class="px-4 text-2xl sm:text-3xl font-bold flex items-center justify-center flex-col md:flex-row">
						<slot name="title">
							<span>Entdecken Sie mehr mit</span>
							<img class="mx-2" src="/images/Logo_cropspot_PLUS.svg">
						</slot>
					</h1>
				</div>

				<ui-button
					v-if="closeable"
					type="blank"
					class="absolute right-5 top-5"
					v-on:click="$bus.$emit('modal:close')"
				>
					<ui-icon class="h-9 w-9" name="x" stroke-width="2" />
				</ui-button>
			</div>
		</template>
		<template v-slot:content>

				<div class="bg-white mb-6 px-4 lg:rounded-b-2xl xl:rounded-b-2xl">
					<div class="">
						<div class="px-6 text-xl">
							<p class="text-center">Dieser Bereich ist exklusiv für unsere cropspot+ Abonnenten.</p>
							<p class="text-center">Holen Sie jetzt Zugriff auf alle Inhalte und Vorteile.</p>
						</div>

						<div class="my-4 px-3 py-3 relative flex justify-center">
							<img class="my-3" src="/images/premium-laptop.png" />
							<img class="absolute left-1/2 top-1/2 -translate-x-[200%] md:-translate-x-[205%] -translate-y-[20%] -rotate-[15deg] max-w-[20%] md:max-w-[12.5%]" src="/images/premium-smartphone.png" />
						</div>
					</div>

					<div class="text-center">
						<page-link
							:absolute="true"
							:href="$route('premium.index')"
						>
							<ui-button
								class="my-5 px-6 py-3"
								label="cropspot+ freischalten!"
							/>
						</page-link>

					</div>
				</div>
		</template>
		<!-- devide -->
	</ui-modal-template>
</template>
<script>

export default {
	props: {
		closeable: {
			type: Boolean,
			default: true,
		},
	}
}
</script>
